<template>
  <!-- v-bind="dragOptions" -->
  <Draggable
    v-bind="dragOptions"
    :class="{ dragArea: isEditing }"
    tag="div"
    :list="category"
    :group="{ name: 'category' }"
  >
    <div :key="getItemKey(item)" v-for="item in category">
      <div class="p-2">
        <div
          class="item"
          :class="{
            'hover:bg-fh-gray-bg': !isEditing,
            'cursor-move': isEditing,
          }"
        >
          <!-- <div v-if="isSub" class="absolute left-[-18px]">
            <i class="pi pi-ellipsis-h" style="color: #e8e8e8" />
          </div> -->
          <div class="flex flex-row justify-between items-center gap-4">
            <div>
              <div class="">{{ item.name }}</div>
              <div
                v-if="!isEditing"
                class="
                  text-sm text-fh-gray
                  mt-2
                  px-4
                  py-1
                  border border-fh-gray-light
                  rounded
                  flex
                  items-center
                  gap-1
                "
              >
                <i class="pi pi-link" />
                <div v-if="item.slug != null">
                  <span class="text-fh-gray-light"
                    >{{ route("category") + slugPrefix }}/</span
                  >{{ item.slug }}/
                </div>
                <div v-else class="text-sm text-fh-gray-light">未設定網址</div>
              </div>
            </div>
            <div v-if="!isEditing">
              <Button
                label="查看商品"
                class="p-button-outlined"
                @click="goToProductPage(item.id)"
              />
              <Button label="編輯" @click="editCategory(item)" />
              <Button
                label="刪除"
                class="p-button-text p-button-danger"
                @click="deleteCategory(item)"
              />
            </div>
          </div>
        </div>
      </div>
      <DraggableNestedCategory
        class="item-sub"
        :isSub="true"
        :slugPrefix="slugPrefix + '/' + item.slug"
        :isEditing="isEditing"
        :category="item.children"
      />
    </div>
  </Draggable>
</template>

<script>
import Draggable from "vuedraggable";
import Button from "primevue/button";

export default {
  name: "DraggableNestedCategory",
  components: {
    Draggable,
    Button,
  },
  data() {
    return {
      drag: false,
      // isEditing: true,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: !this.isEditing,
        ghostClass: "current_destination",
      };
    },
  },
  props: {
    isEditing: {
      type: Boolean,
      required: false,
      default: false,
    },
    category: {
      type: Array,
      required: false,
      default: null,
    },
    isSub: {
      type: Boolean,
      required: false,
      default: false,
    },
    slugPrefix: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    getItemKey(item) {
      if (item.id == null) return item.random;
      else return item.id;
    },
    goToProductPage(id) {
      this.$inertia.visit(route("admin.category.products", id));
    },
    editCategory(item) {
      this.$gemit("category.edit", item);
    },
    deleteCategory(item) {
      let dialog = null;
      if (item.children.length > 0) {
        dialog = {
          message:
            "請注意，此操作會把屬於「" +
            item.name +
            "」的「所有子分類」一併刪除。執行這個動作後無法復原。如要保留子分類，請先使用「順序及層次調整」功能將子分類移出「" +
            item.name +
            "」後再進行刪除。",
          header: "子分類會一併被刪除，是否繼續？",
          acceptLabel: "是，連同子分類一併刪除",
        };
      } else {
        dialog = {
          message:
            "執行這個動作後無法復原，請確認是否要刪除「" +
            item.name +
            "」分類。",
          header: "是否繼續刪除？",
          acceptLabel: "刪除",
        };
      }

      this.$confirm.require({
        message: dialog.message,
        header: dialog.header,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: dialog.acceptLabel,
        rejectLabel: "取消",
        accept: () => {
          this.$inertia.delete(route("admin.category.delete", item.id), {
            only: ["categories"],
            onSuccess: (page) => {
              this.$gemit("category.refresh", page);
            },
          });
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
  },
};
</script>

<style lang="postcss">
.item {
  @apply relative border rounded border-fh-gray-light p-2;
}
.item-sub {
  @apply ml-10;
}
</style>

<style>
.current_destination {
  opacity: 0.5;
  background: #c8ebfb;
}

.dragArea {
  padding: 10px;
  min-height: 40px;
  outline: 1px dashed #e8e8e8;
}
</style>